import { useTranslation } from 'react-i18next'

import { TableUserCell } from '../../../Table'
import { toRecipientArchivedMultiValue } from '../../DocFlow.utils.recipients'
import { DocFlowTableCellInfoIcon } from '../DocFlowTableCellInfoIcon'

import UserIcon from '../../../../icons/user.svg'

function DocFlowTableCellRecipient({
  infoText,
  value,
  withInfo,
  ...restProps
}) {
  const { t } = useTranslation()

  const infoIcon = withInfo ? (
    <DocFlowTableCellInfoIcon content={t(infoText)} />
  ) : null

  const userValue = value
    ? toRecipientArchivedMultiValue(value)
    : {
        Icon: UserIcon,
        user: {
          fullname: t('DocumentStapling.NotfoundRecepientTableNameKey'),
        },
      }

  return (
    <TableUserCell {...restProps} value={userValue}>
      {infoIcon}
    </TableUserCell>
  )
}

export default DocFlowTableCellRecipient
